import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpResponse
} from '@angular/common/http';
import { JwtTokenService } from './jwt-token.service';
import { tap } from 'rxjs/operators';

/**
 * Interceptor HTTP que se encarga de extraer y guardar el token JWT de la respuesta del backend.
 * El token es extraído del header 'Authorization' y guardado en las cookies.
 */
export const securityInterceptResponseService: HttpInterceptorFn = (
  req,
  next
) => {
  const jwtService = inject(JwtTokenService);

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        // Intentar extraer el token del header Authorization
        const authHeader = event.headers.get('Authorization');
        if (authHeader && authHeader.startsWith('Bearer ')) {
          const token = authHeader.substring(7); // Remover "Bearer "
          jwtService.saveToken(token);
          console.log('✅ Token JWT extraído de la respuesta y guardado en cookies');
        }

        // Alternativa: Buscar en headers personalizados comunes
        const xToken = event.headers.get('X-Token');
        const xAuthToken = event.headers.get('X-Auth-Token');
        const jwtToken = event.headers.get('X-JWT-Token');

        if (xToken && !authHeader) {
          jwtService.saveToken(xToken);
          console.log('✅ Token JWT extraído de X-Token header');
        } else if (xAuthToken && !authHeader) {
          jwtService.saveToken(xAuthToken);
          console.log('✅ Token JWT extraído de X-Auth-Token header');
        } else if (jwtToken && !authHeader) {
          jwtService.saveToken(jwtToken);
          console.log('✅ Token JWT extraído de X-JWT-Token header');
        }
      }
    })
  );
};

